<template>
  <div class="overlay">
    <div class="overlay__wrapper">
      <div class="overlay__content">
        <ul
          class="modal__content-list modal__content-list--control modal__content-list--bulk"
        >
          <li class="modal__content-item modal__content-item--title">
            <span class="modal__title">
              {{ this.config.lang["modal.control.upload-bulk"] }}
            </span>
            <span class="modal__close" @click="closeBulkControl"></span>
          </li>
          <li class="modal__content-item modal__control">
            <div class="modal__control_section_left">
              <p class="modal__control_header">
                {{ this.config.lang["modal.control.upload-header"] }}
              </p>
              <!--<div id="bulk-modal-document-error"></div>-->
              <div class="form__formrow form_block">
                <p class="form__row form__wide form_block">
                  <button
                    ref="controlform"
                    class="modal__control_uploadcta"
                    @click="$refs.controlfile.click()"
                    v-html="
                      this.config.lang['modal.control.dateien-auswaehlen']
                    "
                  ></button>
                  <input
                    type="file"
                    ref="controlfile"
                    class="display--none"
                    :accept="
                      this.config.settings['ebrief.upload.accepted_types']
                    "
                    multiple
                  />
                </p>
                <div class="form__row">
                  <ControlFileList
                    :files="this.files"
                    :new="this.numNewFiles"
                    @remove-file="removeFile"
                  />
                </div>
              </div>
              <p class="modal__control_header">
                {{ this.config.lang["modal.control.attachments-header"]
                }}<img
                  class="ebrief-tooltip tipso_style upload__section_header_tooltip"
                  src="/build/images/info-circle-darkgrey.svg"
                  data-tipso-key="upload-attachment-info"
                  data-tipso-moveleft="2"
                  data-tipso-movetop="1"
                  alt="Info"
                  style="left: 7px; position: relative; top: 3px; height: 16px"
                />
              </p>
              <p class="modal__control_header_sub">
                {{ this.config.lang["modal.control.attachments-header-sub"] }}
              </p>
              <div class="form__formrow form__formrow-flat">
                <div class="form__formrow form__formrow--left">
                  <label
                    for="bulk-parameter-attachments"
                    class="form__pincheckbox form__pincheckbox--pointer"
                  >
                    <input
                      class="form__pincheckbox-input"
                      type="checkbox"
                      id="bulk-parameter-attachments"
                      name="bulk-parameter-attachments"
                      value="1"
                      v-model="bulkFileAttachments"
                      @click="refreshAttributes"
                    />
                    <span class="form__pincheckbox-border"></span>
                    <span
                      class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                      v-html="
                        this.config.lang[
                          'modal.control.bulk-file-attachments-text'
                        ]
                      "
                    ></span>
                  </label>
                </div>
                <div
                  ref="controlformuploadblock"
                  class="controlform--upload--attachments"
                  v-show="bulkFileAttachments"
                >
                  <p class="form__row form__wide form_block">
                    <button
                      ref="controlform"
                      class="modal__control_uploadcta"
                      @click="$refs.controattachlfile.click()"
                      v-html="
                        this.config.lang['modal.control.dateien-auswaehlen']
                      "
                    ></button>
                    <input
                      type="file"
                      ref="controattachlfile"
                      class="display--none"
                      :accept="
                        this.config.settings[
                          'ebrief.attachments.accepted_types'
                        ]
                      "
                      multiple
                    />
                  </p>
                  <div class="form__row form__wide form_block">
                    <ControlAttachmentList
                      :attachments="this.attachments"
                      :new="this.numNewAttachments"
                      @remove-attachment="removeAttachment"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal__control_section_right">
              <p class="modal__control_header">
                {{ this.config.lang["modal.control.printsettings-header"] }}
              </p>
              <div class="form__formrow">
                <p class="form__row">
                  <label
                    for="bulk-parameter-colortype"
                    class="modal__control_label"
                  >
                    {{
                      this.config.lang[
                        "modal.control.printsettings-label-color"
                      ]
                    }}
                  </label>
                  <select
                    id="bulk-parameter-colortype"
                    name="parameter-colortype"
                    class="js-ms-dropdown form__select--modalcontrol"
                  >
                    <option
                      v-for="option in this.config.printparameter.bulk.colorType
                        .select"
                      :value="option.value"
                      :data-image="option.image"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </p>
                <p class="form__row">
                  <label
                    for="bulk-parameter-printtype"
                    class="modal__control_label"
                  >
                    {{
                      this.config.lang[
                        "modal.control.printsettings-label-print"
                      ]
                    }}
                  </label>
                  <select
                    id="bulk-parameter-printtype"
                    name="parameter-printtype"
                    class="js-ms-dropdown form__select--modalcontrol"
                  >
                    <option
                      v-for="option in this.config.printparameter.bulk.printType
                        .select"
                      :value="option.value"
                      :data-image="option.image"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </p>
              </div>
              <div class="form__formrow">
                <p class="form__row">
                  <label
                    for="bulk-parameter-splitingtype"
                    class="modal__control_label splitingtype"
                    ><span
                      v-html="
                        this.config.lang[
                          'modal.control.printsettings-label-spliting'
                        ]
                      "
                    ></span
                    ><img
                      class="ebrief-tooltip tipso_style upload__section_header_tooltip"
                      src="/build/images/info-circle-darkgrey.svg"
                      data-tipso-key="upload-split-letters"
                      data-tipso-moveleft="2"
                      data-tipso-movetop="1"
                      alt="Info"
                      style="
                        left: 7px;
                        position: relative;
                        top: 3px;
                        height: 16px;
                      "
                  /></label>
                  <select
                    id="bulk-parameter-splitingtype"
                    name="parameter-splitingtype"
                    class="form__select--modalcontrol"
                    v-model="splitingType"
                  >
                    <option
                      v-for="option in this.config.printparameter.bulk
                        .splitingType.select"
                      :value="option.value"
                      :data-sv-show="option.show"
                      :data-sv-hide="option.hide"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </p>
                <p class="form__row">
                  <span
                    id="side-spliting"
                    class="side-spliting"
                    v-if="splitingType === 'BULKSIDESPLITING'"
                  >
                    <label class="modal__control_label"> &nbsp; </label>
                    <input
                      id="side-spliting-value"
                      class="modal__control_input"
                      type="text"
                      v-model="splitingSideValue"
                      placeholder="0"
                    />
                    <label
                      for="side-spliting-value"
                      class="modal__control_label modal__control_label--spliting-value"
                      v-html="
                        this.config.lang[
                          'modal.control.printsettings-label-sidespliting'
                        ]
                      "
                    ></label>
                  </span>
                  <span
                    id="word-spliting"
                    class="word-spliting"
                    v-if="splitingType === 'BULKWORDSPLITING'"
                  >
                    <label
                      for="word-spliting-value"
                      class="modal__control_label modal__control_label--spliting-value"
                      v-html="
                        this.config.lang[
                          'modal.control.printsettings-label-wordspliting'
                        ]
                      "
                    ></label>
                    <input
                      id="word-spliting-value"
                      class="modal__control_input"
                      type="text"
                      v-model="splitingWordValue"
                      placeholder=" "
                    />
                  </span>
                </p>
              </div>

              <p class="modal__control_header">
                {{ this.config.lang["modal.control.papersettings-header"] }}
              </p>

              <div class="form__formrow">
                <p class="form__row">
                  <label
                    for="bulk-parameter-papertype"
                    class="modal__control_label"
                  >
                    {{
                      this.config.lang[
                        "modal.control.printsettings-label-papertype"
                      ]
                    }}
                  </label>
                  <select
                    id="bulk-parameter-papertype"
                    name="parameter-papertype"
                    class="js-ms-dropdown form__select--modalcontrol"
                    v-model="paperType"
                  >
                    <option
                      v-for="option in this.config.printparameter.bulk.paperType
                        .select"
                      :value="option.value"
                    >
                      {{ option.text }}
                    </option>
                  </select>
                </p>
                <div class="form__formrow form__formrow--left">
                  <p class="modal__control_label">
                    <span
                      v-html="this.config.lang['modal.control.sendc4-header']"
                    ></span
                    ><img
                      class="ebrief-tooltip tipso_style upload__section_header_tooltip"
                      src="/build/images/info-circle-darkgrey.svg"
                      data-tipso-key="upload-c4"
                      data-tipso-moveleft="2"
                      data-tipso-movetop="1"
                      alt="Info"
                      style="left: 7px; position: relative; top: 3px; height: 16px"
                    />
                  </p>
                  <label
                    for="bulk-parameter-c4letter"
                    class="form__pincheckbox form__pincheckbox--pointer form__pincheckbox--oneline"
                  >
                    <input
                      class="form__pincheckbox-input"
                      type="checkbox"
                      id="bulk-parameter-c4letter"
                      name="bulk-parameter-c4letter"
                      value="1"
                      v-model="c4letter"
                    />
                    <span class="form__pincheckbox-border"></span>
                    <span
                      class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                      v-html="
                        this.config.lang['modal.control.sendc4-description']
                      "
                    ></span>
                  </label>
                </div>
              </div>
              <ReturnEnvelope
                :configdata="configdata"
                v-model="returnEnvelopeValues"
                ref="returnEnvelopeRef"
                @remove-error="removeValidationError"
                @add-validation-error="addValidationError"
              />
              <p
                class="modal__control_header "
                v-html="
                  this.config.lang['modal.control.registeredletter-header']
                "
              ></p>
              <div class="form__formrow form__formrow--left">
                <label
                  for="bulk-parameter-registeredletter"
                  class="form__pincheckbox form__pincheckbox--pointer"
                >
                  <input
                    class="form__pincheckbox-input"
                    type="checkbox"
                    id="bulk-parameter-registeredletter"
                    name="bulk-parameter-registeredletter"
                    value="1"
                    v-model="registeredLetter"
                  />
                  <span class="form__pincheckbox-border"></span>
                  <span
                    v-if="this.useriscompany"
                    class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                    v-html="
                      this.config.lang[
                        'modal.control.registeredletter-label-business'
                      ]
                    "
                  ></span>
                  <span
                    v-if="!this.useriscompany"
                    class="form__pincheckbox-label form__pincheckbox-label--colorblue"
                    v-html="
                      this.config.lang[
                        'modal.control.registeredletter-label-privat'
                      ]
                    "
                  ></span>
                </label>
              </div>
              <div class="modal__control_action">
                <div v-if="this.validationError" class="form__validation_error">
                  <p id="errorOutput" class="form__errors">
                    {{ this.validationError }}
                  </p>
                </div>
                <p
                  class="modal__control_actionwrapper modal__control_actionwrapper_submit"
                >
                  <button
                    class="form__button form__button--green modal__control_submit"
                    @click="submitBulkControl"
                  >
                    {{ this.config.lang["modal.control.action-submit"] }}
                  </button>
                </p>
                <p
                  class="modal__control_actionwrapper modal__control_actionwrapper_close"
                >
                  <a
                    href="javascript:void(0);"
                    class="modal__control_cancel"
                    @click="closeBulkControl"
                  >
                    {{ this.config.lang["modal.control.action-cancel"] }}
                  </a>
                </p>
              </div>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import ValidationService from "../services/ValidationService";
import ControlFileList from "./ControlFileList";
import ControlAttachmentList from "./ControlAttachmentList";
import ReturnEnvelope from "./ReturnEnvelope";

export default {
  name: "BulkLetterControl",
  components: {
    ControlFileList,
    ControlAttachmentList,
    ReturnEnvelope
  },
  props: {
    configdata: {
      type: Object,
      default: () => ({})
    },
    filelist: {
      type: Array,
      default: () => []
    },
    attachmentlist: {
      type: Array,
      default: () => []
    },
    jobcount: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      errordata: {},
      validation: new ValidationService(configdata),
      numNewFiles: 0,
      numNewAttachments: 0,
      colorType: configdata.printparameter.bulk.colorType.default,
      printType: configdata.printparameter.bulk.printType.default,
      paperType: configdata.printparameter.bulk.paperType.default,
      shipmentType: configdata.printparameter.bulk.shipmentType.default,
      registeredLetter: false,
      c4letter: false,
      splitingType: configdata.printparameter.bulk.splitingType.default,
      splitingSideValue: "1",
      splitingWordValue: "",
      bulkFileAttachments: false,
      returnEnvelopeValues: {
        returnEnvelopeCheck: false,
        envelopeType: "RU1",
        returnAddress: configdata.printparameter.bulk.returnAddress ?? ""
      },
      validationError: ""
    };
  },
  watch: {},
  computed: {
    config: function() {
      return configdata;
    },
    useriscompany: function() {
      return configdata.userIsCompany;
    },
    files: function() {
      return this.filelist;
    },
    attachments: function() {
      return this.attachmentlist;
    }
  },
  methods: {
    setDefaults() {
      this.colorType = this.config.printparameter.bulk.colorType.default;
      $("#bulk-parameter-colortype")
        .msDropdown()
        .data("dd")
        .set("selectedIndex", 0);

      this.printType = this.config.printparameter.bulk.printType.default;
      $("#bulk-parameter-printtype")
        .msDropdown()
        .data("dd")
        .set("selectedIndex", 0);

      this.paperType = this.config.printparameter.bulk.paperType.default;
      $("#bulk-parameter-papertype")
        .msDropdown()
        .data("dd")
        .set("selectedIndex", 0);

      this.splitingType = this.config.printparameter.bulk.splitingType.default;
      $("#bulk-parameter-splitingtype")
        .msDropdown()
        .data("dd")
        .set("selectedIndex", 0);

      this.splitingSideValue = "1";
      this.splitingWordValue = "";
      this.bulkFileAttachments = false;
      this.c4letter = false;
      this.$refs.returnEnvelopeRef.setDefaults();
      this.validationError = "";
      this.registeredLetter = false;
    },
    removeValidationError() {
      this.validationError = "";
    },
    closeBulkControl() {
      this.setDefaults();
      this.$emit("update-files", []);
      this.$emit("update-attachments", []);
      this.$emit("close-bulk-modal");
    },
    updateFilelist() {
      this.$emit("update-files", this.files);
    },
    refreshAttributes() {
      this.$emit("update-attachments", []);
    },
    updateAttachmentlist() {
      this.$emit("update-attachments", this.attachments);
    },
    submitBulkControl() {
      this.$emit("update-files", this.files);
      this.$emit("update-attachments", this.attachments);

      let shipmentType = this.config.printparameter.single.shipmentType.default;
      if (this.registeredLetter) {
        shipmentType = this.config.printparameter.single.shipmentType
          .registered;
      }
      let splitingValue = undefined;
      if (
        this.splitingType ===
        this.config.printparameter.bulk.splitingType.default
      ) {
        splitingValue = this.splitingSideValue;
      } else {
        splitingValue = this.splitingWordValue;
      }

      let letter = null;

      if (this.c4letter) {
        letter = "C4";
      }

      let parameter = {
        jobType: this.config.printparameter.bulk.jobType,
        colorType: this.colorType,
        printType: this.printType,
        shipmentType: shipmentType,
        splitingType: this.splitingType,
        paperType: this.paperType,
        splitingValue: splitingValue,
        letterType: letter
      };
      if (this.returnEnvelopeValues.returnEnvelopeCheck) {
        parameter = {
          ...parameter,
          returnEnvelopeType: this.returnEnvelopeValues.envelopeType,
          returnAddress: this.returnEnvelopeValues.returnAddress
        };
        let validated = this.validation.validateReturnEnvelope({
          returnAddress: this.returnEnvelopeValues.returnAddress
        });
        if (!validated.success) {
          this.validationError = validated.errorMessage;
          return;
        }
      }

      this.$emit("submit-upload", parameter);
      this.setDefaults();
      this.$emit("close-bulk-modal");
    },
    removeFile(index) {
      this.files.splice(index, 1);
    },
    removeAttachment(index) {
      this.attachments.splice(index, 1);
    },
    addValidationError(errorMessage) {
      this.validationError = errorMessage;
    }
  },
  mounted() {
    [
      ("drag",
      "dragstart",
      "dragend",
      "dragover",
      "dragenter",
      "dragleave",
      "drop")
    ].forEach(
      function(evt) {
        this.$refs.controlform.addEventListener(
          evt,
          function(e) {
            e.preventDefault();
            e.stopPropagation();
          }.bind(this),
          false
        );
      }.bind(this)
    );
    let that = this;
    this.$refs.controlform.addEventListener(
      "drop",
      function(e) {
        that.numNewFiles = 0;
        that.validation.startValidation(
          this.config.types.bulk.jobType,
          that.jobcount
        );
        for (let i = 0; i < e.dataTransfer.files.length; i++) {
          if (
            that.validation.checkFileIsValid(
              e.dataTransfer.files[i],
              that.files,
              "file"
            )
          ) {
            that.files.push(e.dataTransfer.files[i]);
            that.numNewFiles++;
          }
        }
        that.updateFilelist();
        that.errordata = that.validation.getValidation();
        if (that.errordata.countErrors > 0) {
          this.$emit("open-error-modal", that.errordata);
        }
      }.bind(this)
    );
    this.$refs.controlfile.addEventListener(
      "change",
      function(e) {
        that.numNewFiles = 0;
        that.validation.startValidation(
          this.config.types.bulk.jobType,
          that.jobcount
        );
        for (let i = 0; i < e.target.files.length; i++) {
          if (
            that.validation.checkFileIsValid(
              e.target.files[i],
              that.files,
              "file"
            )
          ) {
            that.files.push(e.target.files[i]);
            that.numNewFiles++;
          }
        }
        this.updateFilelist();
        that.errordata = that.validation.getValidation();
        e.target.value = "";
        if (that.errordata.countErrors > 0) {
          this.$emit("open-error-modal", that.errordata);
        }
      }.bind(this)
    );
    this.$refs.controattachlfile.addEventListener(
      "change",
      function(e) {
        that.numNewAttachments = 0;
        that.validation.startValidation(
          this.config.types.bulk.jobType,
          that.jobcount
        );
        for (let i = 0; i < e.target.files.length; i++) {
          if (
            that.validation.checkFileIsValid(
              e.target.files[i],
              that.attachments,
              "attachment"
            )
          ) {
            that.attachments.push(e.target.files[i]);
            that.numNewAttachments++;
          }
        }
        this.updateAttachmentlist();
        that.errordata = that.validation.getValidation();
        e.target.value = "";
        if (that.errordata.countErrors > 0) {
          that.errordata.countAccepted = 1;
          that.errordata.attachment = 1;
          this.$emit("open-error-modal", that.errordata);
        }
      }.bind(this)
    );
    $("#bulk-parameter-colortype")
      .msDropdown({ visibleRows: 2 })
      .change(function() {
        that.colorType = $("#bulk-parameter-colortype option:selected").val();
      });
    $("#bulk-parameter-printtype")
      .msDropdown({ visibleRows: 2 })
      .change(function() {
        that.printType = $("#bulk-parameter-printtype option:selected").val();
      });
    $("#bulk-parameter-splitingtype")
      .msDropdown({ visibleRows: 2 })
      .change(function() {
        that.splitingType = $(
          "#bulk-parameter-splitingtype option:selected"
        ).val();
      });

    $("#bulk-parameter-papertype")
      .msDropdown({ visibleRows: 2 })
      .change(function() {
        that.paperType = $("#bulk-parameter-papertype option:selected").val();
      });
  }
};
</script>
